import { useHistory } from "react-router";
import { useAppSelector } from "../../../../effects/useAppSelector";
import { ArrangerPipeline } from "../../../../types/amr-pipeline/models/ArrangerPipeline";
import { GridDataItem } from "../../../../types/state/GridState";
import { RouteLeavingGuard } from "../../../routing";

const isChangedOrRemoved = (original: ArrangerPipeline, edit?: GridDataItem<ArrangerPipeline>) => {
    if (!edit) return true;

    return (
        original.type !== edit.type ||
        original.reinvestmentPeriodEnd !== edit.reinvestmentPeriodEnd ||
        original.nonCallPeriodEnd !== edit.nonCallPeriodEnd ||
        original.arranger?.referenceName !== edit.arrangerReferenceName ||
        original.collateralManager.referenceName !== edit.collateralManagerReferenceName ||
        original.anchor !== edit.anchor ||
        original.equity !== edit.equity ||
        original.dealStage !== edit.dealStage ||
        original.expectedTiming !== edit.expectedTiming ||
        original.dealLegalName !== edit.dealLegalName ||
        original.euCompliance !== edit.euCompliance ||
        original.collateralType !== edit.collateralType ||
        original.expectedTiming !== edit.expectedTiming ||
        original.dealStage !== edit.dealStage ||
        original.disclosureFile !== edit.disclosureFile
    );
}

interface Props {
    disabled: boolean;
    handleSave: () => void;
}

export function ArrangerPipelineSaveButton({ disabled, handleSave }: Props) {
    const history = useHistory();

    const dataItems = useAppSelector(s => s.grid.dataItems);
    const isSubmitted = useAppSelector(s => s.issuanceMonitor.amrArrangerPipeline.deals.isSubmitted);
    const isSubmitting = useAppSelector(s => s.issuanceMonitor.amrArrangerPipeline.deals.isSubmitting);
    const arrangerPipelines = useAppSelector(s => s.issuanceMonitor.amrArrangerPipeline.deals.arrangerPipelines);

    const nonDraftDataItems = dataItems.filter(d => !d.draft);
    const hasErrors = nonDraftDataItems.some(c => c.errors?.length);

    const hasChanges = () => {
        return (
            (arrangerPipelines && nonDraftDataItems.length > arrangerPipelines.length) ||
            arrangerPipelines?.some(p =>
                isChangedOrRemoved(
                    p,
                    nonDraftDataItems.find(i => i.referenceName === p.referenceName),
                ),
            )
        );
    }

    return (
        <>
            <button
                type="button"
                className="btn btn-main"
                disabled={disabled || hasErrors || isSubmitting}
                onClick={(handleSave)}
            >
                SAVE
            </button>
            {!isSubmitted &&
                <RouteLeavingGuard
                    navigate={(pathname: string) => history.push(pathname)}
                    shouldBlockNavigation={() => hasChanges()}
                />}
        </>
    )
}